module.exports = __webpack_public_path__ + "static/media/K1_DIFF.9523bb4a.png";